import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
Vue.use(Vuex)
Vue.use(ElementUI);

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/shopping/home',
    },
    {
      path: '/shopping',
      name: 'shopping',
      component: ()=>import('../components/index/index.vue'),
      children:[
        {//登录
          path: 'login',
          name: 'login',
          component: ()=>import('../components/public/login.vue'),
        },
        {//忘记密码
          path: 'forget',
          name: 'forget',
          component: ()=>import('../components/public/forget.vue'),
        },
        {//注册
          path: 'regist',
          name: 'regist',
          component: ()=>import('../components/public/regist.vue'),
        },
        {//首页
          path: 'home',
          name: 'home',
          component: ()=>import('../components/home/home.vue'),
        },
        {//集团品牌
          path: 'company_brand',
          name: 'company_brand',
          component: ()=>import('../components/brand/brand.vue'),
        },
        {//商务合作
          path: 'business',
          name: 'business',
          component: ()=>import('../components/business/business.vue'),
        },
        {//贷款申请
          path: 'loan',
          name: 'loan',
          component: ()=>import('../components/loan/loan.vue'),
        },
        {//场景集采
          path: 'purchase',
          name: 'purchase',
          component: ()=>import('../components/purchase/purchase.vue'),
        },
        {//场景集采详情
          path: 'purchase_detail',
          name: 'purchase_detail',
          component: ()=>import('../components/purchase/detail.vue'),
        },
        {//bondi
          path: 'bondi',
          name: 'bondi',
          component: ()=>import('../components/shopping/bondi.vue'),
        },
        {//商城
          path: 'mall',
          name: 'mall',
          component: ()=>import('../components/shopping/shopping.vue'),
        },
        {//商品详情
          path: 'good_detail',
          name: 'good_detail',
          component: ()=>import('../components/shopping/gooddetail.vue'),
        },
        {//商品搜索
          path: 'goodsearch',
          name: 'goodsearch',
          component: ()=>import('../components/shopping/goodsearch.vue'),
        },
        {//购物车
          path: 'cart',
          name: 'cart',
          component: ()=>import('../components/shopping/cart.vue'),
        },
        {//确认订单
          path: 'confirm_order',
          name: 'confirm_order',
          component: ()=>import('../components/shopping/confirmorder.vue'),
        },
        {//提交订单
          path: 'success_order',
          name: 'success_order',
          component: ()=>import('../components/shopping/successorder.vue'),
        },
        {//订单列表
          path: 'orderlist',
          name: 'orderlist',
          component: ()=>import('../components/shopping/orderlist.vue'),
        },
        
        {//文章
          path: 'introduct',
          name: 'introduct',
          component: ()=>import('../components/article/article.vue'),
        },
        {//个人中心
          path: 'personal',
          name: 'personal',
          component: ()=>import('../components/personal/person.vue'),
        },
        {//供应商店铺
          path: 'supplierstore',
          name: 'supplierstore',
          component: ()=>import('../components/shopping/supplierstore.vue'),
        },
      ]
    },
    {//app下载
      path: '/app_download',
      name: 'app_download',
      component: ()=>import('../components/appload/appload.vue'),
    },
    {//商家登记
      path: '/business_regist',
      name: 'business_regist',
      component: ()=>import('../components/business/businessregist.vue'),
    },
    {//文件详情
      path: '/document_detail',
      name: 'document_detail',
      component: ()=>import('../components/purchase/document.vue'),
    },
    {//订单详情
      path: '/order_detail',
      name: 'orderdetail',
      component: ()=>import('../components/shopping/orderdetail.vue'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js